import React from 'react';

function DinersClub(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="45"
      height="31"
      fill="none"
      viewBox="0 0 45 31"
      {...props}
    >
      <g clipPath="url(#clip0_1166_19075)">
        <path
          fill="#0079BE"
          d="M24.43 30C32.05 30.039 39 23.761 39 16.122 39 7.772 32.05 2 24.43 2h-9.38C7.344 2 1 7.772 1 16.122 1 23.762 7.343 30.04 15.05 30h9.38z"
        ></path>
        <path
          fill="#fff"
          d="M15.023 3.156C7.98 3.16 2.272 8.894 2.266 15.978c.006 7.078 5.713 12.81 12.757 12.81 7.045 0 12.757-5.738 12.757-12.816-.005-7.078-5.712-12.81-12.757-12.816zM6.94 15.978a8.135 8.135 0 015.187-7.584v15.162a8.133 8.133 0 01-5.187-7.578zm10.976 7.583V8.394a8.132 8.132 0 010 15.167z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1166_19075">
          <path fill="#fff" d="M0 0H38V28H0z" transform="translate(1 2)"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default DinersClub;
